export default {
	isValidCode: (state) => state.code && state.code.length === state.CODE_LENGTH
}
